/**
 * Service worker registration and the update hint.
 *
 * The rule that shapes this file: **never interrupt a Catch** (architecture
 * §2.5). A new worker installs in the background and waits; the app shows a
 * quiet, dismissible hint on the next natural open and activates only when the
 * user says so. No reload is ever forced under someone's thumb.
 */

import { registerSW } from 'virtual:pwa-register';

export interface UpdateState {
  /** A new version is installed and waiting. */
  updateReady: boolean;
  /** The app shell is cached; the app now works with no network at all. */
  offlineReady: boolean;
}

export interface SwController {
  /** Activate the waiting worker and reload. Only ever called by a user tap. */
  applyUpdate(): Promise<void>;
}

export function registerServiceWorker(onChange: (state: Partial<UpdateState>) => void): SwController {
  const update = registerSW({
    immediate: true,
    onNeedRefresh() {
      onChange({ updateReady: true });
    },
    onOfflineReady() {
      onChange({ offlineReady: true });
    },
  });

  return {
    applyUpdate: () => update(true),
  };
}
